export default __webpack_public_path__ + "static/Youtube-1.0.0.svg";